<template>
  <div class="loan-stat__inner">

    <!-- Value -->
    <div v-if="loading" class="loan-stat__value loan-stat__value--loading">
      <span class="loan-stat__skeleton"/>
    </div>
    <div v-else-if="repaymentAmount === null" class="loan-stat__value loan-stat__value--error">—</div>
    <div v-else class="loan-stat__value">${{ repaymentAmount.toFixed(2) }}</div>

    <!-- Per-frequency description -->
    <div class="loan-stat__desc">{{ frequencyLabel }}</div>

    <!-- Label -->
    <div class="loan-stat__label">Repayment Amount (Approx.)</div>

  </div>
</template>

<script>
import {debounce} from 'lodash/function';
import {isBetween} from '@modules/shared/helpers/form';
import axios from 'axios';
import store from '@modules/guest/new-applicant/store/store';
import {NEW_APPLICATION} from '@store/constants';

const FREQ_LABELS = {
  weekly:      'Per week',
  fortnightly: 'Per fortnight',
  monthly:     'Per month',
};

export default {
  name: 'RepaymentAmountDisplayCard',
  props: ['amount', 'frequency', 'duration'],
  data() {
    return { loading: true };
  },
  computed: {
    repaymentAmount() {
      return store.state[NEW_APPLICATION.MODULE_NAME].meta.repaymentAmount;
    },
    frequencyLabel() {
      return FREQ_LABELS[this.frequency] || '';
    },
    debouncedGetRepaymentAmount() {
      return debounce(this.getRepaymentAmount, 200);
    },
  },
  watch: {
    amount()    { this.debouncedGetRepaymentAmount(); },
    frequency() { this.debouncedGetRepaymentAmount(); },
    duration()  { this.debouncedGetRepaymentAmount(); },
  },
  methods: {
    async getRepaymentAmount() {
      const loan_amount = Number(this.amount);
      this.loading = true;

      if (!loan_amount || !isBetween(loan_amount, 200, 5000) || !this.duration || !this.frequency) {
        store.commit({ type: NEW_APPLICATION.MUTATIONS.SET_META, payload: { repaymentAmount: null } });
        this.loading = false;
        return;
      }

      try {
        const { data } = await axios.post('/api/getRepaymentAmount', {
          loan_amount: this.amount,
          loan_duration: this.duration,
          frequency: this.frequency,
        });
        store.commit({ type: NEW_APPLICATION.MUTATIONS.SET_META, payload: { repaymentAmount: data } });
      } catch (e) {
        store.commit({ type: NEW_APPLICATION.MUTATIONS.SET_META, payload: { repaymentAmount: null } });
      } finally {
        this.loading = false;
      }
    },
  },
  mounted() {
    this.getRepaymentAmount();
  },
};
</script>

<style scoped lang="scss">
.loan-stat__value--loading {
  opacity: 0.4;
}

.loan-stat__value--error {
  color: #9197A1;
}

/* Shimmer placeholder while loading */
.loan-stat__skeleton {
  display: inline-block;
  width: 90px;
  height: 1em;
  border-radius: 6px;
  background: linear-gradient(90deg, #E7E4DA 25%, #F0EEE7 50%, #E7E4DA 75%);
  background-size: 200% 100%;
  animation: fm-shimmer 1.4s ease-in-out infinite;
  vertical-align: middle;
}

@keyframes fm-shimmer {
  0%   { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}
</style>
